import { Global, css, useTheme } from '@emotion/react';
import { breakpoint } from './themes';
import './font.css';

const GlobalStyle = () => {
  const theme = useTheme();

  const style = css`
    /* html, */

    body,
    #root {
      width: 100%;
      height: var(--vh);
      margin: 0;
      padding: 0;
      background: ${theme.backgroundColor.base};
      color: ${theme.content.hierarchy1};
      --rsbs-bg: ${theme.backgroundColor.bg_dark_2};
      --rsbs-ml: auto;
      --rsbs-mr: auto;
      --rsbs-max-w: ${breakpoint.mobile_large};
    }

    :root {
      font-family: Pretendard, sans-serif, system-ui, Avenir, Helvetica, Arial;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-weight: 400;
      line-height: 1.5;
      text-rendering: optimizeLegibility;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      font-synthesis: none;
      -webkit-text-size-adjust: 100%;
      ${theme.mixins.scroll.default};
    }

    html,
    body,
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    i,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark,
    audio,
    video {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      border: 0;
      font: inherit;
      font-size: 100%;
      line-height: 1;
      vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */

    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
      display: block;
    }

    ol,
    ul {
      list-style: none;
    }

    blockquote,
    q {
      quotes: none;
    }

    blockquote:before,
    blockquote:after,
    q:before,
    q:after {
      content: '';
      content: none;
    }

    table {
      border-spacing: 0;
      border-collapse: collapse;
    }

    input {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
      background: none;
      font-family: Pretendard;
    }

    button {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
      background: none;
      font-family: Pretendard;
      cursor: pointer;
    }

    textarea {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
      background: none;
      font-family: Pretendard;

      &::placeholder {
        font-family: Pretendard;
      }
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    img {
      vertical-align: top;
    }

    .a11y {
      display: inline-block;
      width: 1px;
      height: 1px;
      margin: -1px;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
      clip-path: inset(50%);
    }

    .block {
      overflow: hidden;
    }

    [data-rsbs-content] {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 16px;
    }

    [data-rsbs-header]:before {
      content: '';
      display: block;
      position: absolute;
      top: calc(16px + env(safe-area-inset-top));
      left: 50%;
      width: 32px;
      height: 4px;
      transform: translateX(-50%);
      background-color: ${theme.content.content_light_3};
    }

    [data-rsbs-backdrop] {
      z-index: 20;
      /* max-width: ${breakpoint.mobile_large}; */
    }

    [data-rsbs-overlay] {
      z-index: 99;
      border-radius: 16px 16px 0 0;
      /* max-width: ${breakpoint.mobile_large}; */
    }

    * {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  `;

  return <Global styles={style} />;
};

export default GlobalStyle;
